import { COLOR } from '@tmapy/config';
import { createDefaultStyle } from './utils/styleFactory';
export const LINE_DASH = [10, 5];
export const LINE_WIDTH = 3;
export const OUTLINE_WIDTH = 1;
export const STYLE = {
    DEFAULT: createDefaultStyle({ color: COLOR.DEFAULT }),
    HIGHLIGHT: createDefaultStyle({ color: COLOR.HIGHLIGHT }),
    ACTIVE: createDefaultStyle({ color: COLOR.ACTIVE }),
};
// feature needs to be at top when highlighted or active
STYLE.ACTIVE.forEach((style) => style.setZIndex(1));
STYLE.HIGHLIGHT.forEach((style) => style.setZIndex(2));
export const ARROW_SIZE = 3;
//# sourceMappingURL=style.js.map